import React from 'react';
import bookCover from './../Assets/Images/bookCover.png';
import { Link, useNavigate } from 'react-router-dom';
import EyeNotAllowed from '../Assets/Icons/EyeNotAllowed';
import EyeAllowed from '../Assets/Icons/EyeAllowed';
import EditIcon from '../Assets/Icons/EditIcon';
import DeleteIcon from '../Assets/Icons/DeleteIcon';
import { assetURL } from '../api/utils';

function Book({ data, deleteFun, updateFunction, index }) {
  const navigate = useNavigate();
  return (
    <div
      className="book w-full max-w-full flex justify-center mt-[47px] mr-7 md:max-w-[350px] transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105  "
      key={index}>
      <div className="bookBackground px-11 bg-[#ECECEC] w-full  book-cover flex justify-center rounded-lg py-[32px] transition ease-in-out delay-150 hover:bg-[#EEF2F0]">
        <div className="bookDetails  mt-[-52px] flex flex-col items-center">
          {/* <img src={bookCover}  className='border-[1px] border-[#7B867C] rounded-xl	w-[256px] h-[360px]'/> */}
          <img
            src={data.cover_img_url ? data.cover_img_url : `${assetURL}${data.cover_img}`}
            className="border-[1px] border-[#7B867C] rounded-xl	w-[256px] h-[360px] cursor-pointer"
            onClick={() => {
              navigate(`/book/book-Volumes?bookId=${data._id}`);
            }}
          />
          <p
            dir="ltr"
            className="naamKitab w-full urduText font-bold text-2xl mt-[31px] mb-[25px]  text-text-ellipsis"
            style={{ textAlign: 'right' }}>
            {data.bookName}
          </p>
          <div className="buttonBook w-full">
            <div className="tools flex items-center  justify-center flex-wrap">
              {data.status === 'pending' ? (
                <button
                  onClick={() => {
                    updateFunction({
                      ...data,
                      status: 'approved',
                    });
                  }}
                  className="text-white bg-black flex font-semibold items-center justify-center h-[48px] md:w-[145px] w-full mr-[8px]  rounded-xl transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105">
                  <EyeNotAllowed className="mr-[6px]" />
                  Unpublished
                </button>
              ) : (
                <button
                  onClick={() => {
                    updateFunction({
                      ...data,
                      status: 'pending',
                    });
                  }}
                  className={`bg-white text-[#2a9134] flex font-semibold items-center justify-center h-[48px] md:w-[145px] w-full mr-[8px] rounded-xl transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105`}>
                  <EyeAllowed className="mr-[6px]" />
                  Published
                </button>
              )}

              <div className="flex items-center md:justify-start justify-between md:w-auto md:mt-0 mt-[8px] w-full">
                <button
                  onClick={() => {
                    navigate(`/book/add-book?book=${data._id}`);
                  }}
                  className="text-white bg-white md:w-[48px] w-[48%] flex items-center justify-center h-[48px] mr-[8px]  rounded-xl transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105 ">
                  <EditIcon width={24} height={24} fill="#000" />
                </button>
                <button
                  onClick={() => deleteFun(data)}
                  className="text-white bg-[#ca3030] md:w-[48px] w-[48%]  flex items-center justify-center h-[48px]  rounded-xl transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105">
                  <DeleteIcon pathProp={{ fill: '#fff' }} />
                </button>
              </div>
            </div>
            <Link to={`/book/category?id=${data._id}`}>
              <button className="bg-white w-full text-[#2a9134] border-[1px] border-[#2a9134] h-[48px] rounded-xl mt-[8px]  font-semibold leading-[10px] transition ease-in-out delay-150 hover:-translate-y-0.5 hover:scale-105">
                View Content
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Book;
